/**
 * @returns <svg />
 * @note `SvgIcon` 컴포넌트를 사용하지 않음.
 */
export default function SFCloseIcon({ color }: { color?: string }) {
  return (
    // <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#C1C1C1" />
      <path
        d="M8 8L12 12M12 12L16 8M12 12L8 16M12 12L16 16"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // </SvgIcon>
  );
}
